/*
* 
* A simple console logging utility for displaying output and keeping
* track of things inside the SDK.
* 
*/
define('logger',['utils/time'], function(Time) {
  var callCount = [];
  var saveSize = 0;

  return {
    history: [],
    log: function() {
      if (typeof console == 'undefined' || typeof console.log == 'undefined' || !console.log) {
        return;
      }
      console.log(arguments);
      for(var i = 0; i < arguments.length; i++) {
        this.history.push(arguments[i]);
      }
    },

    // Add a timestamp representing when an API call was made
    addCall: function() {
      callCount.push(Time.local('unix'));
      if (callCount.length >= 50) {
        this.log('WANRING: Too many API calls are being made to id.net');
      }

      for (var i = 0; i < callCount.length; i++) {
        if (callCount[i] + 300 < Time.local('unix')) { 
          delete callCount[i];
        }
      }
    },

    // Get the number of API calls in the last 5 mins
    getCalls: function() {
      for (var i = 0; i < callCount.length; i++) {
        if (callCount[i] + 300 < Time.local('unix')) {
          delete callCount[i];
        }
      }

      return callCount.length;
    },

    setSaveSize: function(str) {
      if (typeof str == 'string') {
        saveSize = str.length;
      }
    },

    getSaveSize: function() {
      return saveSize;
    }
  }
});

